import { TextField } from '@material-ui/core';
import React from 'react';
import { FieldLabel } from './field-label';
/**
 * Text / number / multiline / select field with its label + optional info dot
 * rendered above the input. The label sits outside the MUI TextField so the
 * info dot is never clipped by the input's overflow or the floating-label
 * animation. No variant or size override — the field inherits the same MUI
 * defaults as the rest of the form.
 */
export const TextInput = ({ info, label, ...rest }) => (React.createElement("label", { style: { display: 'flex', flexDirection: 'column', gap: 4 } },
    React.createElement(FieldLabel, { info: info, label: label }),
    React.createElement(TextField, { fullWidth: true, ...rest })));
